var map = {
	"./AAVE.png": 502,
	"./AVAX.png": 503,
	"./Army.png": 504,
	"./BIOS.png": 505,
	"./BNB.png": 506,
	"./BUSD.png": 507,
	"./CHART.png": 508,
	"./CNR.png": 509,
	"./CRO.png": 238,
	"./CRYSTL.png": 510,
	"./DXP.png": 511,
	"./ESW.png": 512,
	"./ETH.png": 513,
	"./FTM.png": 239,
	"./GDL.png": 514,
	"./GLMR.png": 240,
	"./GROW.png": 515,
	"./HT.png": 516,
	"./HTZ.png": 241,
	"./INDA.png": 517,
	"./IOTX.png": 242,
	"./LINK.png": 518,
	"./LUDUS.png": 519,
	"./MAI.png": 520,
	"./MATIC.png": 521,
	"./METIS.png": 243,
	"./MOVR.png": 244,
	"./MTV.png": 245,
	"./OKT.png": 246,
	"./ONE.png": 247,
	"./PERA.png": 522,
	"./RELAY.png": 299,
	"./SDN.png": 248,
	"./SUSHI.png": 523,
	"./TUSD.png": 249,
	"./UNI.png": 524,
	"./WAS.png": 525,
	"./WETH.png": 526,
	"./WISB.png": 527,
	"./XCAD.png": 250,
	"./XIOT.png": 528,
	"./YFI.png": 529,
	"./ZERO.png": 530,
	"./heco-icon.png": 531,
	"./wBTC.png": 532,
	"./wDAI.png": 533,
	"./wUSDC.png": 534,
	"./wUSDT.png": 535,
	"./z1INCH.png": 536,
	"./zBTC.png": 537,
	"./zDAI.png": 538,
	"./zETH.png": 539,
	"./zUSDC.png": 540,
	"./zUSDT.png": 541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1018;